/**
 * Filtra as OS da agenda por prestador (client-side).
 * `prestadorId === null` significa "Todos" → devolve tudo.
 */
export function filtrarOSPorPrestador<T extends { prestador_id: string | null }>(
  ordens: T[],
  prestadorId: string | null,
): T[] {
  if (prestadorId === null) return ordens;
  return ordens.filter((os) => os.prestador_id === prestadorId);
}
